import { useTranslation } from '@sib/i18n';
import { FileStatus } from '@sib/types';
import { Button, Loader, Tooltip } from '@sib/ui';
import { Arrow } from '@sib/ui/icons';
import { useFileManagerFileUploadStore } from '@spendbrain/stores/fileUploadStore';

interface UploadFileButtonProps {
  onClick: () => void;
}

export const UploadFileButton = ({ onClick }: UploadFileButtonProps) => {
  const { t } = useTranslation();
  const files = useFileManagerFileUploadStore(store => store.files);
  const uploadingFilesCount = files.filter(
    fileItem => fileItem.status === FileStatus.Uploading
  ).length;
  const isUploading = uploadingFilesCount > 0;
  const buttonLabel = isUploading
    ? t('fileManager.uploadingFiles', { count: uploadingFilesCount })
    : t('fileManager.uploadFiles');

  return (
    <Tooltip content={t('dragAndDrop')} TooltipTriggerProps={{ asChild: true }}>
      <Button onClick={onClick} className="p-0.5 sm:p-[6px]" variant="outline">
        <div className="border-primary/50 flex items-center gap-2 rounded-sm border border-dashed px-1.5 py-0.5 sm:px-3">
          {isUploading ? (
            <Loader className="text-primary h-5" />
          ) : (
            <Arrow className="text-primary h-5" />
          )}
          <p className="text-primary hidden max-w-[140px] truncate leading-4 md:block">
            {buttonLabel}
          </p>
        </div>
      </Button>
    </Tooltip>
  );
};
